import Base from 'app/models/base';

export default Base.extend({

  initialize() {
    const currentMode = this.get('mode');

    if (!currentMode) {
      this.set({ mode: 'production' });
    } else if (currentMode !== 'production') {
      this.set({ mode: 'test' });
    }
  },

  toggle() {
    const currentMode = this.get('mode');
    if (currentMode === 'production') {
      this.set('mode', 'test');
    } else {
      this.set('mode', 'production');
    }
  },
});



// WEBPACK FOOTER //
// ./app/models/api_mode.js